import { ModalsNameType, ModalPropsType, ModalName } from 'features/Modals/ModalProvider';
import { action, computed, makeAutoObservable, observable } from 'mobx';

interface ModalInterface {
    modalName: ModalsNameType;
    payload: ModalPropsType;
}

class ModalStore implements ModalInterface {
    @observable public modalName: ModalInterface['modalName'] = null;
    @observable public payload: ModalPropsType = null;

    public constructor() {
        makeAutoObservable(this);
    }

    @computed
    public get getModalName(): ModalsNameType {
        return this.modalName;
    }

    @computed
    public get getPayload(): ModalPropsType {
        return this.payload;
    }

    @action
    public toggleModal = (modalName: ModalName, modalProps?: ModalPropsType) => {
        this.modalName = this.modalName === modalName ? null : modalName;
        this.payload = modalProps ?? null;
    };

    @action
    public openModal = (modalName: ModalName, modalProps?: ModalPropsType) => {
        this.modalName = modalName;
        this.payload = modalProps ?? null;
    };

    @action
    public closeModal = () => {
        this.modalName = null;
        this.payload = null;
    };
}

export const modalStore = new ModalStore();
